import React, { createContext, useState } from "react";

export const ViewsContext = createContext();

export const ViewsContextProvider = props => {
  const [views, setViews] = useState(null);
  
  return (
    <ViewsContext.Provider value={{ views, setViews }}>
      {props.children}
    </ViewsContext.Provider>
  );
};

